<script>
    import { onMount } from "svelte";
    import { push } from "svelte-spa-router";
    import * as store from "../stores/store";
    import { selectedAs } from "../stores/store";

    onMount(() => {
        // const handleBack = () => {
        //     alert("이미 완료된 배정입니다.");
        //     push("/AsList");
        // };
        // window.addEventListener("popstate", handleBack);
        // return () => {
        //     window.removeEventListener("popstate", handleBack);
        // };
    });
</script>

<div class="main-body custom-complete">
    <div class="complete-container">
        <div class="success-card">
            <div class="icon-section">
                <div class="success-icon-wrapper">
                    <svg
                        viewBox="0 0 24 24"
                        width="48"
                        height="48"
                        stroke="currentColor"
                        stroke-width="3"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </div>
                <div class="confetti-effect"></div>
            </div>

            <div class="text-section">
                <h1>배정 완료!</h1>
                <p class="subtitle">기사님 배정이 성공적으로 처리되었습니다.</p>
            </div>

            <div class="info-summary">
                <div class="summary-item">
                    <span class="label">접수처/수리처</span>
                    <span class="value">
                        #{$selectedAs?.cus_name?.replaceAll("<br>", " / ") ||
                            ""}
                    </span>
                </div>
                <div class="summary-item">
                    <span class="label">제품명</span>
                    <span class="value">{$selectedAs?.item_name || ""}</span>
                </div>
            </div>

            <div class="action-section">
                <button class="primary-btn" on:click={() => push("/AsList")}>
                    목록으로 돌아가기
                </button>
            </div>
        </div>
    </div>
</div>

<style>
    .custom-complete.main-body {
        background-color: var(--bg-primary) !important;
        min-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
    }

    .complete-container {
        width: 100%;
        max-width: 400px;
        animation: fadeIn 0.5s ease-out;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .success-card {
        background-color: var(--bg-secondary);
        border-radius: 24px;
        padding: 40px 32px;
        text-align: center;
        box-shadow: var(--shadow-lg);
        border: 1px solid var(--border-color);
    }

    .icon-section {
        margin-bottom: 32px;
        display: flex;
        justify-content: center;
        position: relative;
    }

    .success-icon-wrapper {
        width: 80px;
        height: 80px;
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 20px rgba(16, 185, 129, 0.3);
        animation: scaleUp 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    @keyframes scaleUp {
        from {
            transform: scale(0);
        }
        to {
            transform: scale(1);
        }
    }

    h1 {
        font-size: 28px;
        font-weight: 800;
        color: var(--text-primary);
        margin-bottom: 8px;
    }

    .subtitle {
        font-size: 15px;
        color: var(--text-secondary);
        margin-bottom: 32px;
    }

    .info-summary {
        background-color: var(--bg-primary);
        border-radius: 16px;
        padding: 20px;
        margin-bottom: 32px;
        border: 1px solid var(--border-color);
    }

    .summary-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
    }
    .summary-item:last-child {
        margin-bottom: 0;
    }

    .label {
        font-size: 13px;
        color: var(--text-tertiary);
    }

    .value {
        font-size: 14px;
        font-weight: 700;
        color: var(--text-primary);
        text-align: right;
    }

    .primary-btn {
        width: 100%;
        padding: 16px;
        background: linear-gradient(135deg, var(--color-primary), #2563eb);
        color: white;
        border: none;
        border-radius: 14px;
        font-size: 16px;
        font-weight: 800;
        cursor: pointer;
        box-shadow: 0 8px 20px rgba(59, 130, 246, 0.3);
        transition: all 0.3s;
    }

    .primary-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 24px rgba(59, 130, 246, 0.4);
    }

    .primary-btn:active {
        transform: scale(0.98);
    }
</style>
